var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2140"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1090",
    d: "M0 0h260v260H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "target",
    "data-name": "\\u30D1\\u30B9 1098",
    d: "M118.423 91.421h82.2a26.917 26.917 0 0 1 26.875 26.9v42.56a26.918 26.918 0 0 1-26.443 26.9v12.216a5.5 5.5 0 0 1-9.391 3.887l-16.09-16.108h-57.152a26.917 26.917 0 0 1-26.875-26.9v-42.56a26.917 26.917 0 0 1 26.876-26.895Zm82.2 85.357a15.9 15.9 0 0 0 15.875-15.9v-42.56a15.9 15.9 0 0 0-15.875-15.9h-82.2a15.9 15.9 0 0 0-15.875 15.9v42.56a15.9 15.9 0 0 0 15.875 15.9h59.432a5.5 5.5 0 0 1 3.891 1.613l8.31 8.319v-4.432a5.5 5.5 0 0 1 5.5-5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "target",
    "data-name": "\\u30D1\\u30B9 1099",
    d: "M64.444 168.579a5.5 5.5 0 0 1-5.5-5.5v-12.225a26.919 26.919 0 0 1-26.445-26.9v-42.56a26.918 26.918 0 0 1 26.876-26.9h82.2a26.917 26.917 0 0 1 26.875 26.9 5.5 5.5 0 0 1-11 0 15.9 15.9 0 0 0-15.875-15.9h-82.2a15.906 15.906 0 0 0-15.876 15.9v42.56a15.906 15.906 0 0 0 15.876 15.9h5.068a5.5 5.5 0 0 1 5.5 5.5v4.432l8.31-8.319a5.5 5.5 0 1 1 7.782 7.774l-17.7 17.721a5.5 5.5 0 0 1-3.891 1.617Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq);
export default __webpack_public_path__ + "static/media/icon_faq.c6523f47172b11fc451f7847fe7b3d94.svg";
export { ForwardRef as ReactComponent };